// @flow
import Cookies from 'universal-cookie'

// eslint-disable-next-line import/prefer-default-export
export const getToken = (req = null) => {
  const cookies = req ? new Cookies(req.headers.cookie) : new Cookies()
  const token = cookies.get('token') || ''
  return token
}
